export const ACCEPTED_CONSENTS_BASE_KEY = 'accepted-consents';

export const acceptedConsentsApiQueryKeys = {
  all: () => [ACCEPTED_CONSENTS_BASE_KEY] as const,
  pdfUrl: (id: string) => [ACCEPTED_CONSENTS_BASE_KEY, id, 'pdf-url'] as const,
};
